import { Provider } from '@vgtv/api-client';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import type { ProviderAccessMap } from '@vgtv/svp-access/lib/access_mappings';

import { getAssetAccessLevel } from '../../shared/helpers/assetHelpers';
import { getUtmParams } from '../../services/tracking/helpers/utmParams';
import { isHermesApp, isIOS, isSportApp } from '../../utils/device';
import { config } from '../../config';
import { getPurchaseUrl } from '../Paywall/PaywallPopup/helpers/getPurchaseUrl';
import { getCategoryShortPath } from '../../shared/helpers/categoryHelpers';
import { getCurrentPageViewData } from '../../services/tracking/helpers/pulseOrigin';

function getSubscriptionUrl(
  asset: SvpAssetAdditional,
  overrides: {
    access?: ProviderAccessMap[Provider];
    code?: string;
  } = {}
) {
  const access = overrides.access || getAssetAccessLevel(asset);
  const { provider } = config;
  const assetId = asset.id;

  if (provider === Provider.VGTV) {
    if (isHermesApp && isIOS) {
      return `https://www.vg.no/i/${isSportApp ? '25PMrr' : 'eMWAwO'}`;
    }

    return getPurchaseUrl(String(assetId), {
      code: access === 'sport' ? 'VGS-1M129-E' : 'VGB-1W49-E',
      content_id: 'fallback',
    });
  } else if (provider === Provider.AB) {
    if (isHermesApp && isIOS) {
      return 'https://www.aftonbladet.se/a/rqpaA';
    }

    const subscriptionUrl =
      'https://payment.schibsted.com/authn/payment/purchase/code';

    const assetId = asset.id;
    const source = '';
    const category = getCategoryShortPath(asset.category);
    const utmParams = getUtmParams();

    const x_domain_id = getCurrentPageViewData().xDomainId;

    const query = {
      refpartner: source,
      client_id: '4f1692bb9daf7cd367000001',
      publisher: 'ab',
      type: 'MediaAsset',
      utm_source: utmParams.utm_source || 'editorial',
      utm_channel: utmParams.utm_channel || `abtv-${category}`,
      utm_campaign: utmParams.utm_campaign || 'abplus_video',
      utm_content: utmParams.utm_content || 'inline_video_teaser',
      redirect_uri: 'https://www.aftonbladet.se/callback',
      // utm_term: 'aftonbladettv,olof-rohlander',
      // custom parameter to track url of purchase click
      utm_url: window.location.href.split('?')[0],
      content_id: assetId,
      code: overrides.code ?? 'AB-2M129-E-VIDEO-149',
      state: JSON.stringify({ returnPath: window.location.href }),
      ...(x_domain_id && { x_domain_id }),
    };

    const queryString = Object.entries(query)
      .map(([key, val]) => {
        return [key, encodeURIComponent(val)].join('=');
      })
      .join('&');

    return `${subscriptionUrl}?${queryString}`;
  }

  return '';
}

export { getSubscriptionUrl };
